import { useField, FieldHookConfig } from 'formik';
import React, { FC, HTMLProps } from 'react';
import RequiredIndicator from '../required-indicator/required-indicator';

// https://github.com/jaredpalmer/formik/issues/2780
export const FieldSelect: FC<FieldHookConfig<string> & HTMLProps<HTMLSelectElement>> = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    const hasError = meta.touched && meta.error;
    return (
        <div className={`form-group ${hasError ? 'form-group--error' : ''}`}>
            <label className="label-overline" htmlFor={props.name}>
                {label} {props.required && <RequiredIndicator />}
            </label>
            <select className="bg-transparent form-control" {...field} {...props} />
            {hasError ? <div className="form-error-msg">{meta.error}</div> : null}
        </div>
    );
};
export default FieldSelect;
